<template>
  <Toolbar
    :actions="toolbar.buttons ?? []"
    :breadcrumb-items="toolbar.breadcrumbs ?? []"
  />

  <BCard
    v-if="toolbar.filters"
    body
    class="mb-4"
  >
    <div class="row align-items-center">
      <div class="col-auto">
        <div class="row">
          <div class="col-auto">
            <BFormInput
              v-model="search"
              placeholder="Buscar"
              style="min-width: 20em !important"
              type="search"
              @keyup.enter="onSubmitSearch"
            />
          </div>
          <div class="col-auto">
            <DateRangeFilter
              :value="dateValue"
              @update="onUpdateDate"
            />
          </div>
          <LayoutButton
            v-if="search"
            filter
            @click="onClearSearch"
          >
            "{{ search }}"
          </LayoutButton>
          <LayoutButton
            v-if="date.start && date.end"
            filter
            @click="onClearDate"
          >
            {{ dateValueName }}
          </LayoutButton>

          <div
            v-for="(filter, index) in toolbar.filters"
            :key="index"
          >
            <LayoutButton
              v-if="filter.value"
              filter
              @click="filter.click"
            >
              {{ filter.value }}
            </LayoutButton>
          </div>
        </div>
      </div>
    </div>
  </BCard>

  <div class="row">
    <div
      v-for="(stat, index) in toolbar.stats"
      :key="index"
      class="col-sm-6 col-md"
    >
      <BCard class="mb-4">
        <div class="d-flex align-items-center">
          <i
            class="display-3"
            :class="stat.icon"
          ></i>
          <div class="ml-3 w-100">
            <div class="text-muted small">{{ stat.title }}</div>
            <div class="text-large">
              <div v-if="typeof stat.value === 'number'">
                <span>{{ maskNumber(stat.value) }}</span>
                <span v-if="stat.suffix">{{ stat.suffix }}</span>
              </div>
              <div v-else>
                <span>{{ stat.value }}</span>
              </div>
            </div>
          </div>
        </div>
      </BCard>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BCard } from "bootstrap-vue";
import { computed, ref } from "vue";
import { maskNumber } from "@/globals/methods";
import DateRangeFilter from "@/components/comum/toolbar/DateRangeFilter.vue";
import LayoutButton from "../../buttons/LayoutButton.vue";
import Toolbar from "../../toolbar/Toolbar.vue";

withDefaults(
  defineProps<{
    toolbar?: {
      buttons?: any[];
      breadcrumbs?: any[];
      filters?: any[];
      stats?: any[];
    };
  }>(),
  { toolbar: () => ({ filters: undefined }) },
);

const emit = defineEmits<{
  "filter-date": [date: { start: string; end: string }];
  "submit-search": [search: string];
}>();

const search = ref("");
const dateValueName = ref("");
const date = ref({ end: "", start: "" });

const dateValue = computed(() => (date.value.start && date.value.end ? `${date.value.start},${date.value.end}` : null));

function onClearSearch() {
  search.value = "";
  emit("submit-search", "");
}

function onUpdateDate(payload: { key: string; label: string; value: string; valueName: string }) {
  const [start, end] = payload.value.split(",");
  dateValueName.value = payload.valueName;
  date.value = { end, start };
  emit("filter-date", { end, start });
}

function onClearDate() {
  dateValueName.value = "";
  date.value = { end: "", start: "" };
  emit("filter-date", { end: "", start: "" });
}

function onSubmitSearch() {
  emit("submit-search", search.value);
}
</script>
